/* Step 13 and Step 22 */
import { ReactElement } from 'react';
import { Field, useFormikContext } from 'formik';
import { FormType } from '@constants';
import { LimitedTextAreaLargeUpdated, FileUploadGroup } from '@components';
import { iFVSInfoDisplay } from '@interfaces/interfaces';

interface iApplicationReasons {
  displayObject: iFVSInfoDisplay;
  currentStepNo: string;
}

function ApplicationReasons({ displayObject, currentStepNo }: iApplicationReasons): ReactElement {
  const { values }: { values: any } = useFormikContext();
  const { pageTitle, pageSubtitle } = displayObject.pages.applicationReasons[currentStepNo];
  const { reason } = displayObject.pages.applicationReasons[currentStepNo].fields;
  const firstParty = values.ApplicationLodger === 'LodgedByVictim';

  return (
    <>
      <div className="vfH2">{pageTitle}</div>
      <p className="subHeadingH3">{pageSubtitle}</p>
      { firstParty ? (
        <p>
          Please tell us how the family violence:
        </p>
      ) : (
        <p>
          Please tell us how the family violence:
        </p>
      )}
      { firstParty ? (
        <ul>
          <li>is linked to the behaviour that resulted in the fines – if you were responsible for the fines, or</li>
          <li>meant that you could not nominate the person who was responsible for the fines, or</li>
          <li>meant that you could not reject a nomination from someone else – if you were not responsible for the fines</li>
        </ul>
      ) : (
        <ul>
          <li>is linked to the behaviour that resulted in the fines – if you were responsible for the fines, or</li>
          <li>meant that you could not nominate the person who was responsible for the fines, or</li>
          <li>meant that you could not reject a nomination from someone else – if you were not responsible for the fines</li>
        </ul>
      )}
      <p>
        If you received the fines due to a mental health condition linked to the family violence, then we may need a report from a relevant health practitioner, such as a general practitioner or psychologist. The report should tell us how your mental health condition contributed to the behaviour that resulted in the fines.
      </p>
      <p>
        If you need more space, you can attach it as a separate document below.
      </p>
      <p>
        If the application and supporting evidence does not include enough information, we will ask you for more information.
      </p>
      <Field component={LimitedTextAreaLargeUpdated} name={reason.formikName} value={values.ReasonForApplication} limit={3000} title={reason.title} isMandatory />
      <p className="vfH3">You may also provide other supporting documents (optional)</p>
      <p>Attach other supporting documents (maximum of 5 files - each file should be less than 4MB)</p>
      <FileUploadGroup
        uploadAReport="OtherSupportingDocNameField"
        uploadFieldArrayName="OtherSupportingAttachments"
        whoPrepared="OtherSupportingFilesProvider"
        briefDescription="OtherSupportingFilesDescription"
        fileSizeErrorField="OtherReportNameFieldErrorHandle"
        fileUploadFailErrorField="OtherReportNameFileUploadErrorHandle"
        UploadFileSectionError="OtherUploadFileSectionError"
        fileSizelimit="4"
        totalFileLimit={5}
        formType={FormType.FAMILYVIOLENCESCHEME}
      />
      <br />
    </>
  );
}

export default ApplicationReasons;
